import { createBrowserRouter } from 'react-router';
import { url } from './utils/constants';

import AuthLayout from './components/layouts/AuthLayout';
import NoAuthLayout from './components/layouts/NoAuthLayout';

import BrandsList from './containers/brands/BrandsList';
import ChannelPartnersList from './containers/channel-partners/ChannelPartnersList';
import ClientsList from './containers/clients/ClientsList';
import ContactsList from './containers/contacts/ContactsList';
import Dashboard from './containers/dashboard/Dashboard';
import Styleguide from './containers/dashboard/Styleguide';
import ForgotPassword from './containers/general/ForgotPassword';
import Home from './containers/general/Home';
import NotFound from './containers/general/NotFound';
import ResetPassword from './containers/general/ResetPassword';
import SessionExpired from './containers/general/SessionExpired';
import TooManyRequests from './containers/general/TooManyRequests';
import InteractionsList from './containers/interactions/InteractionsList';
import UserList from './containers/users/UserList';
import UserView from './containers/users/UserView';
import LocationsList from './containers/locations/LocationsList';
import AiAgentsList from './containers/ai-agent/AiAgentsList';
import AiNumbersList from './containers/ai-agent/AiNumbersList';

const router = createBrowserRouter([
    {
        path: '/',
        element: <NoAuthLayout />,
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: url.sessionExpired,
                element: <SessionExpired />,
            },
            {
                path: url.account.forgotPassword,
                element: <ForgotPassword />,
            },
            {
                path: `${url.account.resetPassword}/:secret`,
                element: <ResetPassword />,
            },
            {
                path: url.tooManyRequests,
                element: <TooManyRequests />,
            },
        ],
    },
    {
        path: url.adminPortal.dashboard,
        element: <AuthLayout />,
        children: [
            {
                index: true,
                element: <Dashboard />,
            },
            {
                path: '/dashboard/styleguide',
                element: <Styleguide />,
            },
            {
                path: url.adminPortal.users.list,
                element: <UserList />,
            },
            {
                path: url.adminPortal.users.view(':id'),
                element: <UserView />,
            },
            // Interactions
            {
                path: url.adminPortal.interactions,
                element: <InteractionsList />,
            },
            // contacts
            {
                path: url.adminPortal.contacts,
                element: <ContactsList />,
            },
            // locations
            {
                path: url.adminPortal.locations,
                element: <LocationsList />,
            },
        ],
    },
    {
        path: url.adminPortal.internalAdmin.base,
        element: <AuthLayout />,
        children: [
            // clients
            {
                path: url.adminPortal.internalAdmin.clients.list,
                element: <ClientsList />,
            },
            // channel partners
            {
                path: url.adminPortal.internalAdmin.channelPartners.list,
                element: <ChannelPartnersList />,
            },
            // Brands
            {
                path: url.adminPortal.internalAdmin.brands.list,
                element: <BrandsList />,
            },
            // admin locations
            {
                path: url.adminPortal.internalAdmin.locations.list,
                element: <LocationsList />,
            },
            // Assign AI Agent
            {
                path: url.adminPortal.internalAdmin.assignAgent.list,
                element: <AiAgentsList />,
            },
            {
                path: url.adminPortal.internalAdmin.assignAgent.agents,
                element: <AiAgentsList />,
            },
            {
                path: url.adminPortal.internalAdmin.assignAgent.numbers,
                element: <AiNumbersList />,
            },
        ],
    },
    {
        // 404 Page
        path: '*',
        element: (
            <NoAuthLayout>
                <NotFound />
            </NoAuthLayout>
        ),
    },
]);

export default router;
